import { colors } from '../theme';

export const analyticsCardStyles = {
  shell: {
    maxWidth: '900px',
    margin: '1rem auto',
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.02), transparent), rgba(20, 26, 24, 0.96)',
    borderRadius: '22px',
    boxShadow: colors.shadow,
    overflow: 'hidden',
    border: `1px solid ${colors.panelBorder}`
  },
  header: {
    background: 'linear-gradient(135deg, rgba(70, 187, 137, 0.94), rgba(70, 187, 137, 0.72))',
    color: '#11201c',
    padding: '1rem 1.2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '0.75rem',
    flexWrap: 'wrap'
  },
  titleWrap: {
    display: 'grid',
    gap: '0.18rem'
  },
  eyebrow: {
    margin: 0,
    fontSize: '0.76rem',
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    fontWeight: 700,
    opacity: 0.72
  },
  title: {
    margin: 0,
    fontFamily: "'Barlow Condensed', 'Barlow', sans-serif",
    fontSize: '2rem',
    lineHeight: 0.95,
    letterSpacing: '0.06em',
    textTransform: 'uppercase'
  },
  body: {
    padding: '1.1rem 1.2rem',
    color: colors.textBody
  },
  section: {
    padding: '1rem',
    borderRadius: '16px',
    border: `1px solid ${colors.panelBorder}`,
    background: colors.surfaceRaised
  },
  statRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1rem',
    alignItems: 'baseline',
    marginBottom: '0.75rem'
  },
  statLabel: {
    color: colors.textMuted
  },
  statValue: {
    color: colors.textStrong,
    fontWeight: 700
  },
  sectionTitle: {
    margin: '0 0 0.7rem',
    color: colors.textStrong,
    fontFamily: "'Barlow Condensed', 'Barlow', sans-serif",
    fontSize: '1.3rem',
    letterSpacing: '0.05em',
    textTransform: 'uppercase'
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  listRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '0.75rem',
    alignItems: 'center',
    marginBottom: '0.45rem'
  },
  barTrack: {
    flex: 1,
    backgroundColor: 'rgba(255,255,255,0.07)',
    borderRadius: '999px',
    overflow: 'hidden',
    marginRight: '0.35rem'
  },
  bar: {
    height: '8px',
    borderRadius: '999px'
  },
  mutedText: {
    color: colors.textDim
  }
};

